<script lang="ts">
  interface defaultEntryPosition {
    left?: string,
    right?: string,
    top?: string,
    bottom?: string,
    zIndex?: number
  }
  import From from "./components/From.svelte"
  import Header from "./components/Header.svelte"
  import Modal from './components/Modal/Modal.svelte'
  import Entry from './components/Entry/Entry.svelte'
  import pkg from '../package.json'
  export let rootFontSize = '12px'
  export let zIndex: number
  export let defaultEntry = true
  export let defaultEntryPosition: defaultEntryPosition = {
    bottom: '5px',
    right: '5px'
  }
  export let defaultEntryStyle = {}
  let modal
  function clickEnrey() {
    modal.open()
  }
  const { version } = pkg
</script>

{#if defaultEntry}
  <Entry clickEnrey={clickEnrey} rootFontSize={rootFontSize} position={defaultEntryPosition} entryStyle={defaultEntryStyle}/>
{/if}
<Modal {...$$props} bind:isOpen={$$props.show} bind:this={modal} mainStyle={`font-size: ${rootFontSize}`}>
  <div slot="header">
    <Header></Header>
  </div>
  <div slot="content" let:close={close}>
    <From {...$$props} closeModal={close}></From>
  </div>
  <div slot="footer">
    <span style="
      position: absolute;
      right: 2px;
      bottom: 2px;
      transform: scale(0.9);
      transform-origin: right bottom;
      opacity: 0.5;
    ">v:{version}</span>
  </div>
</Modal>